import type { CompanyCapabilities } from '@/domain/companies/schemas';

// A feature is on only when its value is true: the backend may send null, and null reads as off.

export const hasFinancialDocuments = ({ fin }: Pick<CompanyCapabilities, 'fin'>) => fin.value === true;

export const hasErpSslVerification = ({ erp_ssl_verification }: Pick<CompanyCapabilities, 'erp_ssl_verification'>) =>
  erp_ssl_verification.value === true;

export const hasVendorPreferences = ({ supplier_form }: Pick<CompanyCapabilities, 'supplier_form'>) =>
  supplier_form.value === true;

export const hasVendorBasedPolicyManagement = ({
  vendor_based_policy_management,
}: Pick<CompanyCapabilities, 'vendor_based_policy_management'>) => vendor_based_policy_management.value === true;

export const hasVendorPreferencesFileImportExport = ({
  import_export_vendor_prefs_file,
}: Pick<CompanyCapabilities, 'import_export_vendor_prefs_file'>) => import_export_vendor_prefs_file.value === true;

export const hasApprovals = ({ approvals }: Pick<CompanyCapabilities, 'approvals'>) => approvals.value === true;

// On, it restricts: only administrators may change approval flows.
export const hasAdminOnlyApprovalFlowChanges = ({
  only_admin_can_change_af,
}: Pick<CompanyCapabilities, 'only_admin_can_change_af'>) => only_admin_can_change_af.value === true;

// Derived by the backend from the company's ERP.
export const hasVendorExpenses = ({ dynamic_features }: Pick<CompanyCapabilities, 'dynamic_features'>) =>
  dynamic_features.support_vendor_expenses === true;
